/**
 * Constants definition.
 *
 * @type {{TCP: string, CNA_SECTOR: string, NEW_CREATION: string}}
 */
const OWNER_SECTOR = {
  TCP: 'TCP',
  CNA_SECTOR: 'CNA',
  NEW_CREATION: 'NEW_CREATION',
  OTHER: 'OTHER',
};

/**
 * Enum definition.
 *
 * @type {string[]}
 */
const OWNER_SECTOR_ENUM = Object.keys(OWNER_SECTOR);

const TCP = OWNER_SECTOR_ENUM[0];
const CNA_SECTOR = OWNER_SECTOR_ENUM[1];
const NEW_CREATION = OWNER_SECTOR_ENUM[2];
const OTHER = OWNER_SECTOR_ENUM[3];

export {
  OWNER_SECTOR,
  TCP,
  CNA_SECTOR,
  NEW_CREATION,
  OWNER_SECTOR_ENUM,
  OTHER,
};
